import { FlowsMoveAcquisitionPrivateSwitchAction } from "./flows-move-acquisition-private-switch.actions";

/**
 * Assure the mockup.json provides intended values for PostalCodes used.
 * */
export const VIEWSTATES = <const>{
  initialized: new FlowsMoveAcquisitionPrivateSwitchAction.Changed({}),
  isMoving: new FlowsMoveAcquisitionPrivateSwitchAction.Changed({
    isMoving: true,
  }),
  isNotMoving: new FlowsMoveAcquisitionPrivateSwitchAction.Changed({
    isMoving: false,
  }),
  fetchPostalCodeWithGridarea: new FlowsMoveAcquisitionPrivateSwitchAction.Fetch.PostalCode("12345"),
  fetchPostalCodeWithoutGridarea: new FlowsMoveAcquisitionPrivateSwitchAction.Fetch.PostalCode("22222"),
  fetchPostalCodeGivingErrorStatus: new FlowsMoveAcquisitionPrivateSwitchAction.Fetch.PostalCode("not valid"),
  loadingPostalCode: new FlowsMoveAcquisitionPrivateSwitchAction.Changed({
    isMoving: true,
    state: "loading-postalcode",
    redirectUrl: "/",
    postalCode: "12345",
  }),
  loadingConsumptionForRange: new FlowsMoveAcquisitionPrivateSwitchAction.Loading("loading-consumption"),
  errorred: new FlowsMoveAcquisitionPrivateSwitchAction.Changed({
    isMoving: true,
    state: "errorred",
    redirectUrl: "/",
  }),
  completedPostalCode: new FlowsMoveAcquisitionPrivateSwitchAction.Changed({
    isMoving: true,
    redirectUrl: "/",
    postalCode: "12345",
    postalTown: "Stockholm",
    gridArea: "STH",
    isBetweenGridAreas: false,
  }),
  completedPostalCodeWithoutGridArea: new FlowsMoveAcquisitionPrivateSwitchAction.Changed({
    isMoving: true,
    redirectUrl: "/",
    postalCode: "21111",
    postalTown: "Malmö",
    gridArea: "",
    energyArea: "SN4",
    isBetweenGridAreas: true,
  }),
  loadingGridArea: new FlowsMoveAcquisitionPrivateSwitchAction.Changed({
    isMoving: true,
    state: "loading-gridarea",
    redirectUrl: "/",
    postalCode: "21111",
    postalTown: "Malmö",
    gridArea: "SKL",
    isBetweenGridAreas: true,
  }),
  completedGridArea: new FlowsMoveAcquisitionPrivateSwitchAction.Changed({
    isMoving: true,
    redirectUrl: "/",
    postalCode: "21111",
    postalTown: "Malmö",
    gridArea: "SKL",
    energyArea: "SN4",
    isBetweenGridAreas: true,
  }),
  hasLowConsumption: new FlowsMoveAcquisitionPrivateSwitchAction.Changed({
    isMoving: true,
    redirectUrl: "/",
    postalCode: "12345",
    postalTown: "Stockholm",
    gridArea: "STH",
    estimatedKwhConsumption: 150000,
  }),
  hasMediumConsumption: new FlowsMoveAcquisitionPrivateSwitchAction.Changed({
    isMoving: true,
    redirectUrl: "/",
    postalCode: "12345",
    postalTown: "Stockholm",
    gridArea: "STH",
    estimatedKwhConsumption: 500000,
  }),
  hasHighConsumption: new FlowsMoveAcquisitionPrivateSwitchAction.Changed({
    isMoving: true,
    redirectUrl: "/",
    postalCode: "12345",
    postalTown: "Stockholm",
    gridArea: "STH",
    estimatedKwhConsumption: 2500000,
  }),
  // TODO: update viewstates to reflect updated and limited usage of state
  // hasConsumptionRangeSelected: new FlowsMoveAcquisitionPrivateSwitchAction.Changed({
  //   isMoving: true,
  //   redirectUrl: "/",
  //   postalCode: "12345",
  //   postalTown: "Stockholm",
  //   gridArea: "STH",
  //   isConsumptionRangeSelected: true,
  // }),
  // hasHousTypeSelected: new FlowsMoveAcquisitionPrivateSwitchAction.Changed({
  //   isMoving: true,
  //   redirectUrl: "/",
  //   postalCode: "12345",
  //   postalTown: "Stockholm",
  //   gridArea: "STH",
  //   estimatedKwhConsumption: 2500000,
  //   houseType: "apartment",
  // }),
  // hasHouseAreaSelected: new FlowsMoveAcquisitionPrivateSwitchAction.Changed({
  //   isMoving: true,
  //   redirectUrl: "/",
  //   postalCode: "12345",
  //   postalTown: "Stockholm",
  //   gridArea: "STH",
  //   houseType: "villa",
  //   houseAreaSliderValue: [20, 150, 300],
  //   estimatedKwhConsumption: 16900,
  //   annualEstimatedConsumption: [
  //     {
  //       livingArea: 20,
  //       estimatedConsumption: {
  //         value: 5720,
  //         unit: "KWH",
  //       },
  //     },
  //     {
  //       livingArea: 150,
  //       estimatedConsumption: {
  //         value: 16900,
  //         unit: "KWH",
  //       },
  //     },
  //     {
  //       livingArea: 300,
  //       estimatedConsumption: {
  //         value: 29800,
  //         unit: "KWH",
  //       },
  //     },
  //   ],
  // }),
};
